export default function StatsCounter() {
  const stats = [
    { value: '2,000+', label: '原创影视作品', icon: 'ri-movie-2-line' },
    { value: '500+', label: '合作创作者', icon: 'ri-user-star-line' },
    { value: '5,000万+', label: '平台注册用户', icon: 'ri-group-line' },
    { value: '9.2', label: '用户平均评分', icon: 'ri-star-line' },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="bg-background-100 border border-background-200/30 rounded-lg p-8 md:p-12">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
            91制片厂的<span className="text-primary-400">数字足迹</span>
          </h2>
          <p className="text-foreground-400 text-sm">用数据说话，见证我们的成长与实力</p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center bg-accent-500/10 rounded-lg">
                <i className={`${stat.icon} text-xl text-accent-400`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-1">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-foreground-400">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}